import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import { getPublicSiteSettings, getPublicActivities } from '../services/api';
import './Activites.css';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

const Activites = () => {
  const [siteSettings, setSiteSettings] = useState(null);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    Promise.all([
      getPublicSiteSettings().then((res) => res?.data).catch(() => ({})),
      getPublicActivities().then((res) => (Array.isArray(res?.data) ? res.data : [])).catch(() => [])
    ]).then(([settings, list]) => {
      setSiteSettings(settings || {});
      setActivities(list || []);
    }).finally(() => setLoading(false));
  }, []);

  const name = siteSettings?.site_name || 'MUTU NDE ESPOIR ASBL';
  const logo = siteSettings?.site_logo || '/logo.png';

  if (loading) {
    return (
      <div className="activites-page">
        <Navigation siteName={name} siteLogo={logo} />
        <div className="page-header activites-header">
          <div className="container">
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div className="spinner" style={{ margin: '0 auto 20px' }}></div>
              <p>Chargement...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="activites-page">
      <Navigation siteName={name} siteLogo={logo} />
      <div className="page-header activites-header">
        <div className="container">
          <h1 className="page-title">Nos Activités</h1>
          <p className="page-subtitle">Les actualités et activités de MUNDES</p>
        </div>
      </div>

      <div className="container activites-container">
        {activities.length === 0 ? (
          <div className="activites-empty">
            <p>Aucune activité publiée pour le moment.</p>
          </div>
        ) : (
          <div className="activites-list">
            {activities.map((a) => (
              <article key={a.id} className="activites-card">
                {a.image_url && (
                  <div className="activites-card-image">
                    <img src={a.image_url} alt={a.title} onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                )}
                <div className="activites-card-body">
                  <h2 className="activites-card-title">{a.title}</h2>
                  {a.activity_date && (
                    <time className="activites-card-date" dateTime={a.activity_date}>
                      {formatDate(a.activity_date)}
                    </time>
                  )}
                  {(a.summary || a.content) && (
                    <div className="activites-card-summary">
                      {expandedId === a.id ? (
                        <>
                          <div className="activites-card-full">{a.content}</div>
                          <button type="button" className="activites-toggle" onClick={() => setExpandedId(null)}>
                            Réduire
                          </button>
                        </>
                      ) : (
                        <>
                          {a.summary || (a.content && a.content.slice(0, 200) + (a.content.length > 200 ? '…' : ''))}
                          {a.content && a.content.length > 200 && (
                            <button type="button" className="activites-toggle" onClick={() => setExpandedId(a.id)}>
                              Lire la suite
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      <footer className="presentation-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} {name}. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Activites;
